<div #discardMessagePromptComponentReact></div>